import React from 'react';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import logo from "../../../images/logoW.png";
import { useNavigate } from 'react-router-dom';
import LanguageSelector from './LanguageSelector'; // Corrige le chemin selon ton arborescence
import { useTranslation } from 'react-i18next';


const HeaderLanding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Navbar bg="light" expand="lg" fixed="top">
      <Container>
        <Navbar.Brand href="#home" className="d-flex align-items-center">
          <img
            src={logo}
            width="100"
            height="50"
            className="d-inline-block align-top mr-2"
            alt="WellBe logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home">{t('landing.header.home')}</Nav.Link>
            <Nav.Link href="#services">{t('landing.header.services')}</Nav.Link>
            <Nav.Link href="#about">{t('landing.header.about')}</Nav.Link>
            <Nav.Link href="#contact">{t('landing.header.contact')}</Nav.Link>
          </Nav>

          <div className="d-flex align-items-center gap-2">
            <Button onClick={() => navigate("/objectifs")} variant="primary">
              {t('landing.header.signup')}
            </Button>
            <Button onClick={() => navigate("/login")} variant="outline-primary">
              {t('landing.header.login')}
            </Button>
            <LanguageSelector />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HeaderLanding;